var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 76,
    viewBox: "0 0 120 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 71.3042C120 72.6806 119.983 74.043 119.948 75.3908C119.913 76.7386 114.899 75 114.952 73.1024C114.984 71.9475 115 72.7802 115 71.6008C115 43.9372 106.181 25.1477 88.3867 16.2258C88.2702 16.2815 88.1425 16.3351 88.0032 16.3866C76.0343 20.8126 44.4036 21.1401 30.0986 16.4879C12.649 25.5126 4 44.2052 4 71.6008V73.5C4 75 1.12622 76.4089 0.0524101 75.3908C0.0174637 74.043 0 72.6807 0 71.3042C0 25.1645 19.6241 0.259514 59.3708 0C64.6159 0.0339392 69.8929 0.490898 75.2658 1.37302C105.197 7.17635 120 31.2316 120 71.3042Z",
    className: "Hair",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairT);
export default __webpack_public_path__ + "static/media/Hair T.28289253410e1094e50482d52a3756d6.svg";
export { ForwardRef as ReactComponent };